import React from "react";


const Dashboard = React.lazy(() => import("../pages/Authenticated/Dashboard"));
const Products = React.lazy(() => import("../pages/Authenticated/Products"));
const Profile = React.lazy(() => import("../pages/Authenticated/Profile"));
const Contact = React.lazy(() => import("../pages/Authenticated/Contact"));

const BalanceTransfer = React.lazy(() => import("../pages/Authenticated/BalanceTransfer"));
const RequestFund = React.lazy(() => import("../pages/Authenticated/RequestFund"));
const FundTransfer = React.lazy(() => import("../pages/Authenticated/FundTransfer"));
const FundReversal = React.lazy(() => import("../pages/Authenticated/FundReversal"));
const YesBankDMT = React.lazy(() => import("../pages/Authenticated/YesDMT"));

const Mpin = React.lazy(() => import("../pages/Authenticated/Mpin"));
const ChangePassword = React.lazy(() => import("../pages/Authenticated/ChangePassword"));
const RDServiceDownload = React.lazy(() => import("../pages/Authenticated/RDServiceDownload"));
const CommissionReport = React.lazy(() => import("../pages/Authenticated/Reports/CommissionReport"));
const ChargesReport = React.lazy(() => import("../pages/Authenticated/Reports/ChargesReport"));
const MyTransactions = React.lazy(() => import("../pages/Authenticated/Reports/MyTransactions"));
const RefundReport = React.lazy(() => import("../pages/Authenticated/Reports/RefundReport"));
const WalletStatement = React.lazy(() => import("../pages/Authenticated/Reports/WalletStatement"));
const MpinReport = React.lazy(() => import("../pages/Authenticated/Reports/MpinReport"));
const AccountManageMent = React.lazy(() => import("../pages/Authenticated/Admin/pages/AccountManagement"));
const Reports = React.lazy(() => import("../pages/Authenticated/Reports"));
const NetworkReport = React.lazy(() => import("../pages/Authenticated/Reports/NetworkTransactionReport"));





const COMMON_ROUTES = [
    {
        id: 1,
        title: 'Dashboard',
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor",],
        path: '/dashboard',
        element: <Dashboard />
    },

    {
        id: 2,
        title: "Balance Transfer",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/balance_transfer',
        element: <BalanceTransfer />
    },
    {
        id: 3,
        title: "Request Fund",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/request_fund',
        element: <RequestFund />
    },
    {
        id: 4,
        title: "Fund Transfer",
        users: ["partner", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/fund_transfer',
        element: <FundTransfer />
    },
    {
        id: 5,
        title: "Fund Reversal",
        users: ["partner", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/fund_reversal',
        element: <FundReversal />
    },

    {
        id: 6,
        title: "Profile",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/profile',
        element: <Profile />
    },

    {
        id: 7,
        title: "Contact",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/contact-us',
        element: <Contact />
    },
    {
        id: 8,
        title: "Change Password",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/pwd',
        element: <ChangePassword />
    },
    {
        id: 9,
        title: "Mpin",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/mpinRefund',
        element: <Mpin />
    },
    {
        id: 10,
        title: "RD Service Download",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/rdServiceDownload',
        element: <RDServiceDownload />
    },
    {
        id: 11,
        title: "Reports",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/reports/wallet_statement',
        element: <WalletStatement />
    },

    {
        id: 12,
        title: "Reports",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/reports/refund_report',
        element: <RefundReport />
    },

    {
        id: 13,
        title: "Reports",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/reports/commission_report',
        element: <CommissionReport />
    },
  
    {
        id: 14,
        title: "Reports",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/reports/products',
        element: <MyTransactions />
    },
    {
        id: 15,
        title: "Reports",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/reports/my_transactions',
        element: <MyTransactions />
    },
    {
        id: 16,
        title: "Reports",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/reports/mpin_report',
        element: <MpinReport />
    },
    {
        id: 17,
        title: "Reports",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/reports',
        element: <Reports />
    },

    {
        id: 18,
        title: "Reports",
        users: ["partner", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/reports/network_transaction',
        element: <NetworkReport />
    },

    {
        id: 19,
        title: "Products",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor",],
        path: '/products',
        element: <Products />
    },
    {
        id: 20,
        title: "Admin",
        users: ["partner", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/account_management',
        element: <AccountManageMent />
    },
    {
        id: 21,
        title: "Reports",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/reports/charges_report',
        element: <ChargesReport/>
    },
    // {
    //     id: 37,
    //     title: "Yes DMT",
    //     users: ["retailer",],
    //     path: '/sendmoney',
    //     element: <YesBankDMT />
    // },


]

export default COMMON_ROUTES